// extracted by mini-css-extract-plugin
module.exports = {"tabs":"Tabs_tabs__YQ450"};